import type { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{
  backgroundColor: string;
  textColor?: string;
  backgroundColorHover?: string;
  borderColor?: string;
  hoverTextColor?: string;
}>()(
  (
    theme: Theme,
    {
      backgroundColor,
      textColor,
      backgroundColorHover,
      borderColor,
      hoverTextColor,
    },
  ) => ({
    button: {
      borderRadius: '10px',
      textTransform: 'capitalize',
      height: '56px',
      transition: 'background-color 0.15s linear, filter 0.15s linear',
      backgroundColor: `${backgroundColor} !important`,
      color: textColor ? `${textColor} !important` : undefined,
      fontSize: '16px',
      border: `2px solid ${borderColor}`,

      '&:hover:not(.Mui-disabled)': {
        backgroundColor: `${backgroundColorHover} !important`,
        color: hoverTextColor ? `${hoverTextColor} !important` : undefined,
      },

      '&.Mui-disabled': {
        backgroundColor: `${theme.palette.action.disabledBackground} !important`,
        color: `${theme.palette.action.disabled} !important`,
        borderColor: `${theme.palette.action.disabledBackground} !important`,
      },
    },
    circularProgress: {
      color: textColor,
    },
  }),
);
